import React from "react";
import { muiIconMap } from "../MuiIconMap";
import { NeighbourhoodData } from "../../configs";

function NeighbourhoodInfo() {
  return (
    <div className="mt-3 flex-1 items-center justify-center text-primary-main w-full p-3">
      <h1 className="text-l font-bold mb-3">Neighbourhood Information</h1>
      {NeighbourhoodData.map((category, categoryIndex) => (
        <div key={categoryIndex} className="mb-6">
          <h2 className="text-sm font-semibold mb-3 ">{category.title}</h2>
          <div className="flex flex-col lg:flex-row gap-4 overflow-scroll">
            {category.items.map((item, itemIndex) => (
              <div
                key={itemIndex}
                className="flex items-start gap-1 p-3 bg-primary-main rounded-md shadow-sm"
              >
                <div>
                  <div className="flex flex-row lg:flex-col gap-1 lg:items-center">
                    <div className="text-secondary-main">
                      {muiIconMap[item.icon]}
                    </div>
                    <h3 className="font-bold text-md text-secondary-main lg:text-center">
                      {item.name}
                    </h3>
                  </div>
                  <p className="text-sm text-secondary-medium lg:text-center">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default NeighbourhoodInfo;
